import type { CuriosityReactionNotification } from '@/@types/notification'
import ClickableStackAvatarGroup from '@/components/ClickableStackAvatarGroup'
import ScreenName from '@/components/ScreenName'
import { formatAsRelativeTime } from '@/utils/day'
import useNotificationClickHandler from '@/utils/hooks/useNotificationClickHandler'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './CommentNotification.module.css'
import NotificationContainer from './NotificationContainer'
import NotificationReference from './NotificationReference'

export interface CuriosityNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: CuriosityReactionNotification
}

export default function CuriosityNotification({
	data,
	className,
	...props
}: CuriosityNotificationProps) {
	const {
		actionItem: { users, behavior },
		referenceItem,
		createdAt,
	} = data
	const { handleClick, isClickable } = useNotificationClickHandler(data)

	return (
		<NotificationContainer
			onClick={handleClick}
			isClickable={isClickable}
			className={clsx(styles.container, className)}
			{...props}
		>
			<div className={styles.content}>
				<div className={styles.mainRow}>
					<ClickableStackAvatarGroup data={users.slice(0, 1)} />

					<div className={styles.contentColumn}>
						<header className={styles.header}>
							<div className={styles.headerText}>
								{users[0] && <ScreenName data={users[0]} className={styles.screenName} />}
								<span className={styles.secondaryText}>{behavior}</span>
							</div>
						</header>
					</div>
				</div>
				<footer className={styles.footer}>
					<span>{formatAsRelativeTime(createdAt)}</span>
					<span>回复</span>
				</footer>
			</div>

			<NotificationReference data={referenceItem} />
		</NotificationContainer>
	)
}
